import Routes from "./Routes";
export const SIDEBAR_NAV_MENU_ITEMS = {
  // admin sidebar mainmenu
  mainMenu: [
    {
      name: "Dashboard",
      icon: <i class="bx bxs-home icon"></i>,
      path: Routes.adminRoutes.Dashboard,
    },
  ],

  subMenu: [
    {
      name: "clinic",
      icon: <i class="bx bxs-book-open icon"></i>,
      children: [
        {
          name: "clinic list",
          path: Routes.adminRoutes.Clinic.ClinicList,
        },
        {
          name: "add clinic",
          path: Routes.adminRoutes.Clinic.ClinicAdd,
        },
      ],
    },
    {
      name: "doctors",
      icon: <i class="bx bxs-book-open icon"></i>,
      children: [
        {
          name: "doctors list",
          path: Routes.adminRoutes.Doctors.DoctorsList,
        },
        {
          name: "add doctors",
          path: Routes.adminRoutes.Doctors.DoctorsAdd,
        },
      ],
    },
    {
      name: "Disease blog",
      icon: <i class="bx bxs-book-open icon"></i>,
      children: [
        {
          name: "Disease list",
          path: Routes.adminRoutes.DiseaseBlog.DiseaseList,
        },
        {
          name: "Disease add",
          path: Routes.adminRoutes.DiseaseBlog.DiseaseAdd,
        },
      ],
    },
    {
      name: "Herbs/Foods",
      icon: <i class="bx bxs-book-open icon"></i>,
      children: [
        {
          name: "Herbs Foods list",
          path: Routes.adminRoutes.HerbsFood.HerbsFoodList,
        },
        {
          name: "Herbs Foods add",
          path: Routes.adminRoutes.HerbsFood.HerbsFoodAdd,
        },
      ],
    },
    {
      name: "video blog",
      icon: <i class="bx bxs-book-open icon"></i>,
      children: [
        {
          name: "video blog list",
          path: Routes.adminRoutes.BlogVideos.BlogVideosList,
        },
        {
          name: "video blog add",
          path: Routes.adminRoutes.BlogVideos.BlogVideosAdd,
        },
      ],
    },
    {
      name: "medicine blog",
      icon: <i class="bx bxs-book-open icon"></i>,
      children: [
        {
          name: "medicine blog list",
          path: Routes.adminRoutes.MedicineBlog.MedicineBlogList,
        },
        {
          name: "medicine blog add",
          path: Routes.adminRoutes.MedicineBlog.MedicineBlogAdd,
        },
      ],
    },
    {
      name: "enquiry",
      icon: <i class="bx bxs-book-open icon"></i>,
      children: [
        {
          name: "Doctor enquiry",
          path: Routes.adminRoutes.Enquiry.DoctorEnquiry,
        },
        {
          name: "clinic enquiry",
          path: Routes.adminRoutes.Enquiry.ClinicEnquiry,
        },
      ],
    },
    {
      name: "Healing Stories",
      icon: <i class="bx bxs-book-open icon"></i>,
      children: [
        {
          name: "add Healing Stories",
          path: Routes.adminRoutes.HealingStories.HealingStoriesAdd,
        },
        {
          name: "Healing Stories list",
          path: Routes.adminRoutes.HealingStories.HealingStoriesList,
        },
      ],
    },
  ],
  bottomMenu: [
    {
      name: "go to website",
      icon: <i class='bx bx-globe icon'></i>,
      path: Routes.publicRoutes.HomePage,
    },
    {
      name: "Logout",
      icon: <i class='bx bxs-log-out-circle icon'></i>,
      path: "Logout",
    },
  ],
};